// extracted by mini-css-extract-plugin
export default {"root":"Qf8CT","title":"FUbuQ","euroIcon":"xghwy","item":"Ixl5d","itemIFrame":"sAnHB","itemTitle":"r2jMp","itemLink":"mLFNE"};